import React, { useEffect, useState } from "react";
import {
  DropDownIcon,
  PasswordkeyIcon,
  PersonalInfoImageUploadIcon,
  ProfileEditIcon,
  SettingMenuIcon,
  WorkflowItemRightArrow,
} from "../common/Icon";
import adamSmith from "../../assets/images/png/adam_smith_img.png";
import emailPreference from "../../assets/images/png/emailPreference-img.png";
import { accessAccountData } from "../common/Helper";
import SettingsSidebar from "./SettingsSidebar";
import Header from "../common/Header";
import RichTextEditor from "react-rte";

const MyAccount = () => {
  // DROPDOWN
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");

  //PROFILE IMAGE
  const [showImage, setShowImage] = useState("");
  const changeHandler = (value) => {
    const image = URL.createObjectURL(value);
    setShowImage(image);
  };

  // DROPDOWN DATA
  const options = [
    " (GMT-03:00 Eastern Time (Uk)",
    "(GMT-03:00 Eastern Time (Uk)",
    "Other",
  ];
  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };
  const [value, setValue] = useState(RichTextEditor.createEmptyValue());

  const onChange = (newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <div className="bg-light_purple7 rounded-2xl h-[calc(100vh-32px)] overflow-x-hidden w-full mr-4 relative">
        <div className="px-2 xs:px-5 relative overflow-hidden">
          <div className=" overflow-hidden">
            <Header text="Settings" />
          </div>
          <div className=" pt-2 lg:pt-4">
            <div className="flex justify-between">
              <div className=" flex w-[20%] xm:w-[10%] md:w-[25%] xl:w-[20%] 3xl:w-[13%]">
                <SettingsSidebar />

                <span className="w-[1px] bg-[#F2F2F2] block mx-3 mt-2"></span>
              </div>
              <div className=" overflow-y-auto h-[calc(100vh-185px)] md:h-[calc(100vh-140px)] overflow_x_scroll_style">
                <form className="flex flex-col md:flex-row w-full">
                  <div className=" md:w-[50%] bg-white rounded-[24px] p-[22px_8px_16px_8px] xl:p-[22px_31px_33px_17px]">
                    <div className="flex items-center justify-between">
                      <h4 className="text-base 3xl:text-lg font-bold text-black">
                        Personal Info
                      </h4>
                      <button
                        type="submit"
                        className="save_contact_btn text-[14px] 3xl:text-base !leading-normal font-semibold text-white rounded-[37px] border  border-solid  border-transparent  outline-none px-[12px] pb-[10px] pt-[6px] bg-primary flex items-center hover:bg-white hover:border-primary hover:text-primary duration-200"
                      >
                        save
                        <span className="save_contact_arrow save_arrow pt-[3px]">
                          <WorkflowItemRightArrow />
                        </span>
                      </button>
                    </div>
                    <div className="flex items-center pt-4 sm:pt-6 md:pt-[42px]">
                      <div className="relative inline-block">
                        {showImage ? (
                          <img
                            className="max-w-[67px] h-[67px] rounded-full object-cover"
                            src={showImage}
                            alt="profile-img"
                          />
                        ) : (
                          <img
                            className="max-w-[67px] h-[67px]"
                            src={adamSmith}
                            alt="adam-Smith"
                          />
                        )}

                        <label
                          for="upload-photo"
                          className="bg-primary p-2 rounded-full absolute right-0 bottom-[-8px] cursor-pointer"
                        >
                          <PersonalInfoImageUploadIcon />
                        </label>
                        <input
                          type="file"
                          hidden
                          name="photo"
                          id="upload-photo"
                          required
                          onChange={(e) => changeHandler(e.target.files[0])}
                        />
                      </div>
                      <div className="pl-3 lg:pl-[22px] xl:pl-[42px] w-full">
                        <label
                          className="text-xs 3xl:text-sm font-bold text-black"
                          htmlFor=""
                        >
                          Full name
                        </label>
                        <input
                          placeholder="Full Name"
                          className="text-xs md:text-sm bg-[#FBFBFF] xl:text-base font-normal text-black placeholder:text-xs placeholder:md:text-sm placeholder:xl:text-base outline-primary placeholder:text-black w-full px-2 xl:px-3 py-3 xl:py-4 rounded-lg border border-solid border-[rgba(0,_0,_0,_0.05)] mt-3"
                          type="text"
                          required
                        />
                      </div>
                    </div>
                    <div className="pt-4 sm:pt-6 md:pt-9">
                      <label
                        className="text-xs 3xl:text-sm font-bold text-black"
                        htmlFor=""
                      >
                        Email address
                      </label>
                      <input
                        className="text-xs md:text-sm  bg-[#FBFBFF] xl:text-base font-normal text-black outline-primary placeholder:text-black w-full px-2 xl:px-3 py-3 xl:py-4 rounded-lg border border-solid border-[rgba(0,_0,_0,_0.05)] mt-3"
                        placeholder="Your Email"
                        type="email"
                        required
                      />
                    </div>
                    <div className="pt-4 sm:pt-6 md:pt-9">
                      <label
                        className="text-xs 3xl:text-sm font-bold text-black"
                        htmlFor=""
                      >
                        Phone number
                      </label>
                      <input
                        className="text-xs md:text-sm  bg-[#FBFBFF] xl:text-base font-normal text-black outline-primary placeholder:text-black w-full px-2 xl:px-3 py-3 xl:py-4 rounded-lg border border-solid border-[rgba(0,_0,_0,_0.05)] mt-3"
                        placeholder="9090******"
                        type="number"
                        required
                      />
                    </div>
                  </div>
                  <div className="ml-2 xl:ml-[18px] md:w-[50%] mt-4 sm:mt-6 md:mt-0">
                    <div className="w-full bg-white rounded-[24px]  pt-[25px] pb-6 sm:pb-8 md:pb-12 px-2 xl:px-[22px]">
                      <div className="flex items-center justify-between">
                        <h4 className="text-base 3xl:text-lg font-bold text-black">
                          Password
                        </h4>
                        <button className="text-xs 3xl:text-sm font-normal text-primary py-3 px-2 xl:px-4 flex items-center rounded-[33px] border border-solid border-primary bg-light_purple7 group hover:bg-primary hover:text-white transition-all ease-in-out duration-300">
                          <span className="pr-1">
                            <PasswordkeyIcon />
                          </span>
                          Changes password
                        </button>
                      </div>
                      <div className="pt-4 sm:pt-6 md:pt-8">
                        <label
                          className="text-xs 3xl:text-sm font-bold text-black"
                          htmlFor=""
                        >
                          Current Password
                        </label>
                        <input
                          className="text-xs md:text-sm  bg-[#FBFBFF] xl:text-base font-normal text-black outline-primary placeholder:text-black w-full px-2 xl:px-3 py-3 xl:py-4 rounded-lg border border-solid border-[rgba(0,_0,_0,_0.05)] mt-3"
                          placeholder="*************"
                          type="password"
                          required
                        />
                      </div>
                    </div>
                    <div className="w-full bg-white rounded-[24px]  pt-[25px] pb-6 md:pb-11 px-2 xl:px-[22px] mt-4 sm:mt-6 xl:mt-5">
                      <h4 className="text-base 3xl:text-lg font-bold text-black">
                        Time preference
                      </h4>
                      <div className="pt-5 xl:pt-[35px]">
                        <label
                          className="text-xs 3xl:text-sm font-bold text-black"
                          htmlFor=""
                        >
                          Timezone
                        </label>
                        <div className="rounded-lg relative  border-solid border border-[rgba(0,_0,_0,_0.05)] bg-light_purple7 py-3 xl:py-4 px-2 xl:px-3 mt-3">
                          <div className="flex items-center relative">
                            <p className="text-xs md:text-sm xl:text-base font-normal text-black">
                              {selectedOption || "(GMT-03:00 Eastern Time (Uk)"}
                            </p>
                            <div
                              className="cursor-pointer absolute top-auto right-0 flex justify-center items-center"
                              onClick={() => setIsOpen(!isOpen)}
                            >
                              <span
                                className={`duration-200  ${
                                  isOpen ? "rotate-180" : ""
                                }`}
                              >
                                <span className="timezone-dropdown-icon  block w-[14px] h-3">
                                  <DropDownIcon />
                                </span>
                              </span>
                            </div>
                          </div>
                          {isOpen && (
                            <ul className="cursor-pointer absolute z-50 top-14 right-0 w-[250px] p-0 m-0  list-none bg-white shadow-[ 0px_5.86667px_17.6px_0px_rgba(0,_0,_0,_0.10)] rounded-md py-5">
                              {options.map((option, index) => (
                                <li
                                  className="text-black text-xs 3xl:text-sm font-medium mb-2 hover:bg-[#F6F6F6] hover:text-black px-4 py-3 duration-200"
                                  key={index}
                                  onClick={() => handleOptionClick(option)}
                                >
                                  {option}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                        <div
                          onClick={() => setIsOpen(false)}
                          className={`fixed inset-0 min-h-full w-full z-20  bg-black opacity-10 ${
                            isOpen ? "w-[100%] " : "hidden"
                          }`}
                        ></div>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="w-full bg-white rounded-[24px] pt-5 xl:pt-10 pb-6 xl:pb-12 px-2 xl:px-7 mt-4 sm:mt-6 xl:mt-5">
                  <div className="flex justify-between">
                    <div>
                      <h4 className="text-base 3xl:text-lg font-bold text-black">
                        Email preference
                      </h4>
                      <p className="text-sm 3xl:text-base font-normal text-black pt-2.5">
                        Signature for sending emails from Chatalott
                      </p>
                    </div>
                    <button
                      type="submit"
                      className="text-[14px] 3xl:text-base font-bold email-preference-edit-button text-white rounded-[26px] bg-primary border border-solid border-transparent hover:border-primary p-[8px_10px] sm:p-[10px_14px] h-full flex items-center hover:bg-light_purple7 hover:text-primary  duration-200"
                    >
                      <span className="pr-2.5">
                        <ProfileEditIcon />
                      </span>
                      Edit
                    </button>
                  </div>
                
                  <div className="h-[200px] pt-4">
                    <RichTextEditor value={value} onChange={onChange} />
                  </div>
                  <div className="w-full">
                    <div className="bg-[#F6F6F6] py-3 px-4">
                      <h3 className=" text-[#999999] font-bold text-base">
                        Normal
                      </h3>
                    </div>
                  </div>
                  <div className="pt-5 sm:pt-6 md:pt-[51px]">
                    <h5 className="text-base 3xl:text-lg font-bold text-black">
                      Schedule preference
                    </h5>
                    <p className="text-sm 3xl:text-base font-normal text-black pt-2.5">
                      Allow Chatalott to access account:
                    </p>
                    <div className="pt-8 flex flex-wrap gap-[14px]">
                      {accessAccountData.map((value, index) => {
                        return (
                          <div key={index}>
                            <button className="text-black text-sm 3xl:text-base font-normal py-2 px-2.5 w-[115px] lg:w-[121px] xl:w-[143px] 2xl:w-[134px] 3xl:w-[126px] rounded-[84px] border border-solid border-primary hover:bg-primary hover:text-white hover:border-transparent duration-200">
                              {value.accessAccountBtn}
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyAccount;
